import { LegalClientConstitutionalDocumentParam } from 'api/types/params';
import { CompanyConstituentDocsDateFormType } from 'modules/client/legal/forms/companyConstituentDocsDate';
import { CompanyConstituentDocsFilesFormType } from 'modules/client/legal/forms/companyConstituentDocsFiles';

export const parseConstitutionalDocumentParam = (
  constituentDocsFiles:
    | CompanyConstituentDocsFilesFormType['constituentDocsFiles']
    | undefined,
  constituentDocsDateOfLastChange:
    | CompanyConstituentDocsDateFormType['constituentDocsDateOfLastChange']
    | undefined
): LegalClientConstitutionalDocumentParam | undefined => {
  if (!constituentDocsFiles?.length && !constituentDocsDateOfLastChange) {
    return undefined;
  }

  return {
    dateOfLastChange: constituentDocsDateOfLastChange,
    fileIds: constituentDocsFiles?.map(({ id }) => id!) || [],
  };
};
